export default "__VITE_ASSET__Bl84JOUz__"